@if (isInModal()) {
  <ng-container *ngTemplateOutlet="form" />
} @else {
  <wl-partial-card
    wlAutomationId="card"
    class="{{ content().useAccessibleCalculator ? 'calculate__card' : '' }}"
  >
    <wl-calculate-form-sticker
      slot="header"
      [title]="content().title"
      [subtitle]="content().subtitle"
      [sticker]="content().sticker"
      [stickerContent]="content().stickerContent"
      [stickerFocusLine]="content().stickerFocusLine"
      [stickerTheme]="content().stickerTheme"
      [affiliateLogo]="shownAffiliateLogo()"
    ></wl-calculate-form-sticker>
    @if (!showPromoCodeForm()) {
      <ng-container slot="subheader" *ngTemplateOutlet="badges" />
    }
    <ng-container
      slot="content"
      *ngTemplateOutlet="showPromoCodeForm() ? promoCodeForm : form"
    />
  </wl-partial-card>
}
<a
  class="mt-1 float-end"
  *wlGenericLink="rendering()?.fields?.DirectOrderLink"
></a>

<ng-template #badges>
  @if (promoCode(); as promoCode) {
    <div class="calculate__badge--promocode">
      {{ content().promoCodeLabel | interpolate: { variables: { promoCode } } }}
    </div>
  }
</ng-template>

<ng-template #form>
  <form
    novalidate
    [ngrxFormState]="formState()"
    class="d-flex flex-column gap-3"
    [wlTrackStep]="{
      rendering: rendering(),
      step: 0,
      stepName: 'invullen',
    }"
  >
    <wl-calculate-form-address
      [formState]="formState()"
      [rendering]="rendering()"
      [content]="content()"
      [controls]="controls()"
      [installationAddressStatus]="installationAddressStatus()"
      [installationAddresses]="installationAddresses()"
      [installationAddressNotFound]="installationAddressNotFound()"
      [houseNumberAdditions]="houseNumberExtensions()"
      [manualHouseNumberAdditionInput]="showManualHouseNumberAdditionInput()"
      [isAddressManualTriggerActive]="isAddressManualEntryCompleted()"
      [isAlternateAddressEntryEnabled]="isAddressManualEntryEnabled()"
      (hideManualHouseNumberAdditionInput)="hideHouseNumberInput.emit()"
      (setAddressNextButtonClicked)="setAddressNextButtonClicked()"
      (updateAddressButtonClicked)="addressNextButtonClicked.set(false)"
    />
    @if (content().enableExistingCustomerCheckbox) {
      <wl-calculate-form-existing-customer
        [formState]="formState()"
        [rendering]="rendering()"
        [content]="content()"
        [controls]="controls()"
      />
    }
    @if (showUsageQuestionnaireTrigger()) {
      <wl-calculate-form-questionnaire-trigger
        [formState]="formState()"
        [rendering]="rendering()"
        [content]="content()"
        [controls]="controls()"
        (calculateOpenModal)="openModal.emit($event)"
        (setQuestionnaireContainerVisibility)="hideTriggerContainer.set($event)"
        wlAutomationId="calculate-form-questionnaire-trigger"
      />
    }
    @if (showCalculateFormContainer()) {
      <div
        wlAutomationId="calculate-form-usage-container"
        class="d-flex flex-column gap-3"
      >
        @if (content().smartMeterCheckboxShownAsRadioButtons) {
          <wl-calculate-form-meter
            [content]="content()"
            [controls]="formState().controls"
            [rendering]="rendering()"
            wlAutomationId="meter-radio-buttons"
          />
        }
        <wl-calculate-form-usage
          [formState]="formState()"
          [rendering]="rendering()"
          [content]="content()"
          (calculateOpenModal)="openModal.emit($event)"
          [controls]="controls()"
        />
        <wl-calculate-form-checkboxes
          [rendering]="rendering()"
          [content]="content()"
          [controls]="controls()"
        />
        @if (formState().value.hasSolarPanel) {
          <wl-calculate-form-solar
            [formState]="formState()"
            [rendering]="rendering()"
            [content]="content()"
            [controls]="controls()"
            wlAutomationId="electricity-export"
          />
        }
        <div class="row">
          <div class="col-12">
            @if (content().useAccessibleCalculator) {
              <crnt-button
                (click)="submitCalculate.emit()"
                variant="primary"
                wlAutomationId="calculate-form-submit-button"
                wlTrackLink="true"
                [fullWidth]="true"
                [trackLinkInfo]="{
                  eventType: 'button-click',
                  rendering: rendering(),
                  field: 'bereken je beste bod',
                }"
                [state]="submitButtonState()"
                >{{ content().submitLabel }}
                @if (showSpinnerWhenSubmitButtonDisabled()) {
                  <crnt-icon
                    class="ms-2"
                    icon="spinner-third"
                    animation="spin"
                  />
                }
              </crnt-button>
            } @else {
              <button
                (click)="submitCalculate.emit()"
                wlTrackLink
                [trackLinkInfo]="{
                  eventType: 'button-click',
                  rendering: rendering(),
                  field: 'bereken je beste bod',
                }"
                class="btn btn-sales-primary w-100"
                wlAutomationId="calculate-form-submit-button"
                [disabled]="submitButtonDisabled()"
              >
                <span>{{ content().submitLabel }}</span>
                @if (showSpinnerWhenSubmitButtonDisabled()) {
                  <crnt-icon
                    class="ms-2"
                    icon="spinner-third"
                    animation="spin"
                  />
                }
              </button>
              @if (installationAddressStatus() === 'PENDING') {
                <div class="text-center text-info mt-1">
                  <em>{{ content().checkingAddressMessage }}</em>
                </div>
              }
            }
          </div>
        </div>
      </div>
    }
    @if (content().useAccessibleCalculator) {
      @if (content().footerLink; as footerLink) {
        <div class="row">
          <div class="col-12 text-center border-t">
            <div class="border-top pt-2">
              <crnt-button
                [href]="footerLink.href"
                variant="tertiary"
                state="enabled"
                >{{ footerLink.text }}</crnt-button
              >
            </div>
          </div>
        </div>
      }
    }
  </form>
</ng-template>

<ng-template #promoCodeForm>
  <div *wlGenericRichText="{ value: content().promoCodeFormBody }"></div>
  <form
    novalidate
    id="promo-code-form"
    [ngrxFormState]="promoCodeFormState()"
    (submit)="trackPromoCodeSubmit()"
  >
    <crnt-form-control>
      <crnt-text-input>
        <input
          type="text"
          [ngrxFormControlState]="promoCodeFormState().controls.promoCode"
          [attr.aria-label]="content().promoCodeInputA11yLabel"
        />
      </crnt-text-input>
      @if (promoCodeFormState() | isInvalid) {
        @if (promoCodeFormState().controls.promoCode.errors['required']) {
          <crnt-form-control-validation-message slot="validation">{{
            content().promoCodeRequiredError
          }}</crnt-form-control-validation-message>
        } @else if (
          promoCodeFormState().controls.promoCode.errors['invalidCode']
        ) {
          <crnt-form-control-validation-message slot="validation">{{
            content().promoCodeInvalidError
          }}</crnt-form-control-validation-message>
        }
      }
    </crnt-form-control>

    <crnt-button [fullWidth]="true" type="submit" class="mt-2">
      {{ content().promoCodeFormButton }}
    </crnt-button>
  </form>
</ng-template>
